import * as React from "react";
import { IParagraphMobileCtaProps } from "./ParagraphMobileCtaProps";
import { Container } from "./ParagraphMobileCtaHelpers";
import { graphql } from "gatsby";
import MobileCta from "../../common/MobileCta/MobileCta";

const ParagraphMobileCta: React.FC<IParagraphMobileCtaProps> = (props) => {
  return (
    <Container className="container-sm">
      <MobileCta {...props} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphMobileCta on paragraph__mobile_cta {
    id
    field_title
    field_apple_app_link {
      title
      uri
      url
    }
    field_description_formatted {
      value
      processed
    }
    field_google_app_link {
      title
      uri
      url
    }
    relationships {
      field_media {
        relationships {
          field_media_image {
            publicUrl
            gatsbyImage(
              width: 480
              height: 200
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
      field_icon {
        relationships {
          field_media_file {
            publicUrl
          }
        }
      }
      mobileImage: field_mobile_banner_image {
        field_media_image {
          alt
        }
        relationships {
          field_media_image {
            publicUrl
            gatsbyImage(
              width: 337
              height: 526
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
      desktopImage: field_media {
        field_media_image {
          alt
        }
        relationships {
          field_media_image {
            publicUrl
            gatsbyImage(
              width: 1440
              height: 319
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
  }
`;
export default ParagraphMobileCta;
